import { Waves } from "lucide-react";
import { BUSINESS } from "../data/site";

// Floating sticky "Book Now" button (mobile + desktop) linking to the registration form.
export default function StickyBookNow() {
  return (
    <a
      href={BUSINESS.registrationUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-book-now"
      className="fixed z-50 bottom-5 right-5 sm:bottom-8 sm:right-8 btn-book shadow-xl animate-bookpulse"
      aria-label="Book Now — opens registration form"
    >
      <Waves className="w-4 h-4" />
      Book Now
    </a>
  );
}
